const TYCHI_ROLE_ALIASES = {
  HR: 'Hr Operation',
  'HR ADMIN': 'HR Ops Fundtec',
  'IT ADMIN': 'IT Support',
  FINANCE: 'Fundtec Finance',
  Finance: 'Fundtec Finance',
  MANAGER: 'Manager',
};

export const normalizeTychiRole = (role) => {
  if (!role) return null;
  return TYCHI_ROLE_ALIASES[role] || role;
};

const portalRoleKey = (user) => {
  if (!user) return null;
  return normalizeTychiRole(user.tychi_role) || normalizeTychiRole(user.department) || user.tychi_role || null;
};

/** hr | hr_admin | it | finance | manager | exo | super_admin | null */
export const getPortalKind = (user) => {
  if (!user || user.role !== 'employee') return null;
  const key = portalRoleKey(user);
  if (key === 'Super Admin') return 'super_admin';
  if (['Hr Operation', 'HR'].includes(key)) return 'hr';
  if (['HR Ops Fundtec', 'HR ADMIN'].includes(key)) return 'hr_admin';
  if (['IT Support', 'IT ADMIN'].includes(key)) return 'it';
  if (['Fundtec Finance', 'FINANCE', 'Finance'].includes(key)) return 'finance';
  if (key === 'Manager') return 'manager';
  if (key === 'EXO') return 'exo';
  return null;
};

export const isPortalStaffView = (user) => Boolean(getPortalKind(user));

const HR_TYCHI_ROLES = ['Hr Operation', 'HR Ops Fundtec', 'HR', 'HR ADMIN'];

export const isHrUser = (user) => {
  if (!user) return false;
  if (user.role === 'admin' && (user.dept === 'HR' || user.department === 'HR')) return true;
  const key = user.tychi_role || user.dept || user.department || '';
  return HR_TYCHI_ROLES.includes(key) || key === 'HR';
};

export const isHrPortalView = (user) => getPortalKind(user) === 'hr';

export const isHrAdminPortalView = (user) => getPortalKind(user) === 'hr_admin';

export const isHrOpsPortalView = (user) => {
  const kind = getPortalKind(user);
  return kind === 'hr' || kind === 'hr_admin';
};

export const isItPortalView = (user) => getPortalKind(user) === 'it';

export const isFinancePortalView = (user) => getPortalKind(user) === 'finance';

export const isManagerPortalView = (user) => getPortalKind(user) === 'manager';

export const isExoPortalView = (user) => getPortalKind(user) === 'exo';

/** Boss Super Admin portal — separate from platform Admin */
export const isSuperAdminPortalView = (user) => getPortalKind(user) === 'super_admin';

/** IT / Finance / Manager — dedicated portal UI (not generic employee) */
export const isDeptPortalView = (user) =>
  ['it', 'finance', 'manager'].includes(getPortalKind(user));

export const isHrPortalUser = isHrPortalView;

export const canManageHrOps = (user) =>
  user?.role === 'admin' || isHrOpsPortalView(user) || isSuperAdminPortalView(user);
